/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import useUser from '../../../Shared/UserProvider/useUser'
import { useQuery } from '@tanstack/react-query'
import { isProviderAPos } from '../../../../services/Provider/Provider.service'
import { getNextClosure } from '../../../../services/PointOfSale/PointOfSale.service'
import { differenceInMinutes, format } from 'date-fns'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardExtra } from '../../Shared/Card'
import { Icon } from 'semantic-ui-react'
import { Link } from 'react-router-dom-v5-compat'
import { CardLoadingPlaceholder } from '../../Shared/CardLoadingPlaceholder'


const NextClosureCard = () => {
    const [t] = useTranslation()
    const {user} = useUser()

    const {data, isLoading} = useQuery({
        queryKey: ['next-closure', user.provider.object.id],
        queryFn: () => getNextClosure(user.provider.object.id),
        enabled: isProviderAPos(user.provider),
    })

    const getClosureText = () => {
        if (!data) return ''
        if (data === 'NEVER') return t('dashboard.next_closure.always_open')
        if (data === 'CLOSED') return t('dashboard.next_closure.closed')

        const minutesUntilClosure = differenceInMinutes(new Date(data), new Date())

        if (minutesUntilClosure < 60) {
            return t('dashboard.next_closure.close_in_minute', {count: minutesUntilClosure})
        }

        const hours = Math.floor(minutesUntilClosure / 60)
        const minutes = minutesUntilClosure % 60
        const formattedTime = format(new Date(0, 0, 0, hours, minutes), 'H\'h\'mm')
        return t('dashboard.next_closure.close_in', {count: formattedTime})
    }

    return (
      <Card>
          <CardContent
            css={css`
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 190px;
                height: 62px;
            `}
          >
              {isLoading ? (
                <CardLoadingPlaceholder/>
              ) : (
                <p
                  css={css`
                      margin-left: 1rem;
                      font-weight: bold;
                  `}>
                    {getClosureText()}
                </p>
              )}
          </CardContent>

          <CardExtra>
              <Link
                to={{
                    pathname: '/settings/hours',
                }}>
                  Horaires
                  <Icon name="arrow right"/>
              </Link>
          </CardExtra>
      </Card>
    )
}

export { NextClosureCard }
